import * as v from './rules';

/** Mirrors TitleDtos. */
export const LIMITS = { name: 200, shortName: 60, code: 40, subject: 80, classLevel: 20 };

const capped = (label, max) => (value) =>
  String(value ?? '').trim().length > max ? `${label} must be ${max} characters or fewer` : null;

export const name = (value) => v.required('Title name')(value) ?? capped('Title name', LIMITS.name)(value);

export const shortName = (value) =>
  v.required('Short name')(value) ?? capped('Short name', LIMITS.shortName)(value);

export const code = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return 'Title code is required';
  if (text.length > LIMITS.code) return `Title code must be ${LIMITS.code} characters or fewer`;
  if (!/^[A-Za-z0-9-]+$/.test(text)) return 'Use letters, numbers and hyphens only';
  return null;
};

export const subject = capped('Subject', LIMITS.subject);
export const classLevel = capped('Class', LIMITS.classLevel);

export const SERVER_CODES = { title_code_taken: 'code' };
